import { render } from "./WalletHomepage.vue?vue&type=template&id=68b8b7e1"
import script from "./WalletHomepage.vue?vue&type=script&lang=js"
export * from "./WalletHomepage.vue?vue&type=script&lang=js"

import "./WalletHomepage.vue?vue&type=style&index=0&id=68b8b7e1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__